import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

const WA_PHONE = "5491126597311"; // +54 9 11 2659-7311
const WA_MESSAGES = {
  es: "Hola ATLAS, quiero una demo",
  pt: "Olá ATLAS, gostaria de uma demo",
  en: "Hi ATLAS, I'd like a demo",
  fr: "Bonjour ATLAS, je souhaite une démo",
};

export default function WhatsAppFloat() {
  const { t, lang } = useI18n();
  const msg = WA_MESSAGES[lang] || WA_MESSAGES.es;
  const href = `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(msg)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("cta.whatsapp")}
      data-testid="whatsapp-float"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-40 group"
    >
      <span
        className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping"
        aria-hidden
      />
      <span className="relative flex items-center justify-center h-14 w-14 sm:h-16 sm:w-16 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white shadow-xl shadow-emerald-600/30 transition-all ring-4 ring-white">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="h-7 w-7 sm:h-8 sm:w-8 fill-current"
          aria-hidden
        >
          <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.37.693 4.577 1.887 6.44L4 29l7.77-1.84A12.005 12.005 0 0 0 16.001 27C22.628 27 28 21.627 28 15S22.628 3 16.001 3zm0 21.6c-1.96 0-3.79-.56-5.34-1.53l-.383-.23-4.61 1.09 1.12-4.48-.25-.41A9.52 9.52 0 0 1 6.4 15c0-5.29 4.31-9.6 9.6-9.6s9.6 4.31 9.6 9.6-4.31 9.6-9.6 9.6zm5.3-7.14c-.29-.14-1.72-.85-1.99-.95-.27-.1-.46-.14-.66.14-.19.29-.76.95-.94 1.15-.17.19-.35.22-.64.07-.29-.14-1.23-.45-2.35-1.45-.87-.77-1.46-1.73-1.63-2.02-.17-.29-.02-.45.13-.6.13-.13.29-.35.43-.52.14-.17.19-.29.29-.48.09-.19.05-.36-.02-.5-.07-.14-.66-1.6-.91-2.19-.24-.57-.48-.49-.66-.5-.17-.01-.36-.01-.55-.01-.19 0-.5.07-.76.36-.26.29-1 .98-1 2.38 0 1.4 1.02 2.75 1.16 2.94.14.19 2 3.05 4.85 4.28.68.29 1.21.47 1.62.6.68.22 1.3.19 1.79.12.55-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.33z" />
        </svg>
      </span>
    </a>
  );
}
